/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* OURES: sticky cart native add redirect start */
(function () {
  if (window.__ouresStickyNativeCartRedirect20260509) return;
  window.__ouresStickyNativeCartRedirect20260509 = true;

  var productCache = {};
  var redirecting = false;
  var lastEventAt = 0;

  function norm(value) {
    return String(value || '')
      .replace(/（完売）|\(完売\)|完売/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isStickyAddTarget(target) {
    return !!(target && target.closest && target.closest('.eascStickyAddToCartBtn'));
  }

  function stickyRoot(target) {
    return target && target.closest && (target.closest('#ea-sticky-cart-root') || target.closest('.ea-sticky-cart'));
  }

  function productHandle() {
    var match = location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function fetchProduct() {
    var handle = productHandle();
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);

    return fetch('/products/' + handle + '.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(function (product) {
      productCache[handle] = product;
      return product;
    }).catch(function () {
      return null;
    });
  }

  function selectedStickyValues(root) {
    var values = [];
    if (!root) return values;

    var selectors = root.querySelectorAll('select.easc-variant1, select.easc-variant2, select.easc-variant3');
    Array.prototype.forEach.call(selectors, function (select) {
      var option = select.options && select.options[select.selectedIndex];
      var value = norm((option && (option.value || option.textContent)) || select.value);
      if (value && !/^(カラー|色|サイズ|選択)$/.test(value)) values.push(value);
    });

    return values;
  }

  function selectedNativeVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function quantity(root) {
    var input = root && root.querySelector && root.querySelector('.easc-quantityInput input');
    var value = parseInt(input && input.value, 10);
    if (!Number.isFinite(value) || value < 1) value = 1;
    return Math.min(value, 99);
  }

  function pickVariant(product, root) {
    if (!product || !Array.isArray(product.variants)) return null;

    var selectedValues = selectedStickyValues(root);
    if (selectedValues.length) {
      var matched = product.variants.find(function (variant) {
        var options = [variant.option1, variant.option2, variant.option3].filter(Boolean).map(norm);
        return selectedValues.every(function (value) {
          return options.indexOf(norm(value)) !== -1;
        });
      });
      if (matched) return matched;
    }

    var nativeId = selectedNativeVariantId();
    if (nativeId) {
      return product.variants.find(function (variant) {
        return String(variant.id) === nativeId;
      }) || null;
    }

    return product.variants.find(function (variant) { return variant.available; }) || product.variants[0] || null;
  }

  function setButtonState(button, label, disabled) {
    if (!button) return;
    button.textContent = label;
    button.disabled = !!disabled;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function handleStickyAdd(event) {
    if (!isStickyAddTarget(event.target)) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var now = Date.now();
    if (redirecting || now - lastEventAt < 900) return false;
    redirecting = true;
    lastEventAt = now;

    var button = event.target.closest('.eascStickyAddToCartBtn');
    var root = stickyRoot(event.target);
    setButtonState(button, 'カートへ移動中...', true);

    fetchProduct().then(function (product) {
      var variant = pickVariant(product, root);
      if (!variant || variant.available === false) {
        redirecting = false;
        setButtonState(button, '完売', true);
        return;
      }

      var url = '/cart/add?id=' + encodeURIComponent(variant.id) +
        '&quantity=' + encodeURIComponent(quantity(root)) +
        '&return_to=' + encodeURIComponent('/cart');
      window.location.href = url;
    }).catch(function () {
      redirecting = false;
      setButtonState(button, 'カートに追加', false);
      window.location.href = '/cart';
    });

    return false;
  }

  ['touchend', 'pointerup', 'click'].forEach(function (type) {
    window.addEventListener(type, handleStickyAdd, { capture: true, passive: false });
  });
})();
/* OURES: sticky cart native add redirect end */

/* OURES S0017 live description refresh:start */
(function () {
  function textFromHtml(html) {
    var div = document.createElement('div');
    div.innerHTML = html || '';
    return (div.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function replaceDescription(descriptionHtml) {
    var wrapper = document.querySelector('.product-block-list__item--description .rte.text--pull');
    if (!wrapper || !descriptionHtml) return false;
    wrapper.innerHTML = descriptionHtml;

    var plain = textFromHtml(descriptionHtml).slice(0, 300);
    var metaDescription = document.querySelector('meta[name="description"]');
    var ogDescription = document.querySelector('meta[property="og:description"]');
    if (metaDescription) metaDescription.setAttribute('content', plain);
    if (ogDescription) ogDescription.setAttribute('content', plain);
    return true;
  }

  function refreshS0017Description() {
    if (location.pathname !== '/products/s0017') return;
    fetch('/products/s0017.js?oures_live_description=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product || !product.description) return;
        var forbidden = ['元資料', '明記がない', '目安表記', '日本語表記', '新規ビジュアル', '全体が見える'];
        if (forbidden.some(function (word) { return product.description.indexOf(word) !== -1; })) return;
        replaceDescription(product.description);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshS0017Description);
  } else {
    refreshS0017Description();
  }
  window.addEventListener('pageshow', refreshS0017Description);
})();
/* OURES S0017 live description refresh:end */
